import { Component } from '@grafikr/components';
import { debounceTime, fromEvent } from 'rxjs';

import Filter from 'utils/collection-filter';
import Drawer from 'utils/components/drawer';
import { NonNullish } from 'utils/nullish-check';

export default Component((node, { app }) => {
  const initDrawer = () => {
    const drawer = NonNullish(document.getElementById('filter-drawer'));
    if (!window.matchMedia('(min-width: 1024px)').matches) {
      const filterDrawer = new Drawer(drawer);

      filterDrawer.on('open', async () => {
        document.body.style.overflow = 'hidden';
      });

      filterDrawer.on('close', async () => {
        document.body.style.overflow = '';
      });

      const filterToggles = node.querySelectorAll('[data-filter-toggle]');

      filterToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          filterDrawer.toggle();
        });
      });
    }
  };

  fromEvent(window, 'resize').pipe(debounceTime(250)).subscribe(initDrawer);
  initDrawer();

  Filter(node, app);
});
